import { createApp } from 'vue';
import App from "./App.vue";
import router from "./router";
import Axios from "axios";
import VueAxios from "vue-axios";
import titleMixin from "./mixins";
import { createGtag } from 'vue-gtag-next';

const app = createApp(App);

// Use mixins
app.mixin(titleMixin);

// HTTP requests
app.use(VueAxios, Axios);

// Google Analytics
app.use(createGtag, {
  property: {
    id: "UA-136639659-1"
  }
});

// Use router
app.use(router);

// Mount the App
app.mount("#app");